'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _en = require('./dictionary/en.json');

var _en2 = _interopRequireDefault(_en);

var _fr = require('./dictionary/fr.json');

var _fr2 = _interopRequireDefault(_fr);

var _vi = require('./dictionary/vi.json');

var _vi2 = _interopRequireDefault(_vi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new function LanguageDictionary() {
    var _this = this;

    (0, _classCallCheck3.default)(this, LanguageDictionary);
    this.en = _en2.default;
    this.vi = _vi2.default;
    this.fr = _fr2.default;
    this.userLanguage = "vi";

    this.setDictionary = function (dictionary, userLanguage) {
        if (userLanguage) {
            _this.userLanguage = userLanguage;
        }
        _this[_this.userLanguage] = (0, _assign2.default)({}, _this[_this.userLanguage], dictionary);
    };

    this.setUserLanguage = function (userLanguage) {
        _this.userLanguage = userLanguage;
    };
}();